// src/config/sidebarSections.js

export const createSidebarSections = (navigate, activeKey = null) => {
  return [
    {
      key: 'user-management',
      label: 'User Management',
      icon: '👥',
      defaultOpen: activeKey === 'user-management',
      active: activeKey === 'user-management',
      items: [
        {
          key: 'user-list',
          label: 'List',
          icon: '📋',
          active: activeKey === 'user-list',
          onClick: () => navigate('/user-management/list'),
        },
      ],
    },
    {
      key: 'application',
      label: 'Application',
      icon: '🗂',
      defaultOpen: activeKey?.includes('application') || activeKey?.includes('job'),
      active: activeKey?.includes('application') || activeKey?.includes('job'),
      items: [
        {
          key: 'job-openings',
          label: 'Job Openings',
          icon: '📋',
          active: activeKey === 'job-openings',
          onClick: () => navigate('/job-openings'),
        },
        {
          key: 'candidate',
          label: 'Candidate',
          icon: '🧑',
          active: activeKey === 'candidate',
          onClick: () => navigate('/candidates'),  // ✅ FIXED
        },
        {
          key: 'master',
          label: 'Master',
          icon: '⚙',
          active: activeKey === 'master',
          onClick: () => navigate('/application/master'),
        },
      ],
    },
  ];
};

export default createSidebarSections;